export function selectProductByDepartmentMobile() {
    const forms = document.querySelector('.alpes-forms.mobile-form');

    if(forms){
        const departmentSelect = forms.querySelectorAll('.form-input[name=department]');
        const productSelect = forms.querySelector('.form-input[name=produto]');
        const productSelectOptions = forms.querySelectorAll('.form-input[name=produto] option');


        hideClothesOnLoad(productSelectOptions);

        departmentSelect.forEach((item) => {
        item.addEventListener('change', () => {
            productSelect.value = "";
            showProducts(item.value, productSelectOptions);
        })
    })
    }
}

export function selectProductByDepartment() {
    const forms = document.querySelector('.alpes-forms.banner-form');
    if(forms){
    const departmentSelect = forms.querySelectorAll('.form-input[name=department]');
    const productSelect = forms.querySelector('.form-input[name=produto]');
    const productSelectOptions = forms.querySelectorAll('.form-input[name=produto] option');

    hideClothesOnLoad(productSelectOptions);

    departmentSelect.forEach((item) => {
        item.addEventListener('change', () => {
            productSelect.value = "";
            showProducts(item.value, productSelectOptions);
        })
    })
}
    
}

function showProducts(department, products) {

    let clothes = [];
    let bikes = [];

    products.forEach(product => {

        if (product.getAttribute('data-category') == '160') {
            clothes.push(product);
        } else if (!product.getAttribute('data-text') && !product.getAttribute('data-category')) {
            bikes.push(product);
        }

        if (!department || department != 'vestuario') {
            for (let i=0;i<bikes.length;i++) {
                bikes[i].classList.remove('d-none');
                bikes[i].removeAttribute('disabled');
                
            }
            for (let i=0;i<clothes.length;i++) {
                clothes[i].classList.add('d-none');
                clothes[i].setAttribute('disabled', true);
            }
            
            if (product.getAttribute('data-text') == "1") {
                product.innerHTML = "Modelo";
            }
        }
        else {
            for (let i=0;i<bikes.length;i++) {
                bikes[i].classList.add('d-none');
                bikes[i].setAttribute('disabled', true);
            }
            for (let i=0;i<clothes.length;i++) {
                clothes[i].classList.remove('d-none');
                clothes[i].removeAttribute('disabled');
            }
            
            if (product.getAttribute('data-text') == "1") {
                product.innerHTML = "Produto";
            }
        }
    })
}

function hideClothesOnLoad(items) {
    items.forEach(item => {
        if (item.getAttribute('data-category') == '160'){
            item.classList.add('d-none');
        }
    })
}